<div class="scss-clipboard-card-scroll-title d-flex justify-content-between align-items-start padding-y-8 padding-left-16 padding-right-8">
    <div class="typography-body-medium-strong padding-y-8">
        <ng-content select="[header]"></ng-content>
    </div>
    <div class="d-flex gap-1 mb-2">
        <div #menu>
            <ng-content select="[menu]"></ng-content>
        </div>
        @if (!hasMenu) {
            <lib-icon-button
                [icon]="Icon.Common.ContentCopy"
                [size]="ButtonSize.Small"
                [kind]="ButtonKind.NeutralTertiary"
                (clicked)="Copy()">
            </lib-icon-button>
        }
    </div>
</div>
<div class="scss-clipboard-card-scroll-body-outer">
    <div class="scss-clipboard-card-body-inner padding-16 typography-body-medium" #content>
        <ng-content select="[body]"></ng-content>
    </div>
</div>
<ng-content select="[footer]"></ng-content>
